<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="travelPlans"
            :items-per-page="500"
            hide-default-footer
            fixed-header
            :disable-pagination="true"
        >
            <template v-slot:item.title="{ item }">
                <div class="d-flex align-center py-1">
                    <div
                        v-if="item.city && item.city.media && item.city.media.length"
                        class="travel-plan-city-image-wrapper"
                    >
                        <v-img :src="item.city.media[0].original_url"/>
                    </div>
                    <div class="pl-2 font-weight-medium">
                        {{ item.title }}
                    </div>
                </div>
            </template>
            <template v-slot:item.city="{ item }">
                {{ item.city ? item.city.name[$i18n.locale] : '' }}
            </template>
            <template v-slot:item.start="{ item }">
                {{ fullDateFormat(item.start) }}
            </template>
            <template v-slot:item.end="{ item }">
                {{ fullDateFormat(item.end) }}
            </template>
            <template v-slot:item.guests="{ item }">
                {{ getGuestsLabel(item) }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ fullDateFormat(item.created_at, true) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <div class="d-flex align-center justify-end">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                :href="item.url"
                                target="_blank"
                                rel="noopener noreferrer"
                                class="mr-2 my-travel-plans-guide-edit-btn"
                                @click.stop
                            >
                                <v-btn
                                    x-small
                                    fab
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-pencil-outline</v-icon>
                                </v-btn>
                            </a>
                        </template>
                        <span>{{ $t('Edit') }}</span>
                    </v-tooltip>

                    <v-menu
                        bottom
                        right
                        offset-y
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="cursor-pointer text-capitalize rounded-xl my-travel-plans-guide-actions-btn"
                                elevation="0"
                                color="black"
                                icon
                            >
                                <v-icon>
                                    mdi-dots-vertical
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item @click.stop="openDeleteTravelPlanModal(item)">
                                <v-list-item-icon class="mr-2">
                                    <v-icon color="red">mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>
                                    {{ $t('Delete') }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>
        </v-data-table>

        <modal
            :show="showDeleteTravelPlanModal"
            :title="$t('travel_plans.delete_modal.title')"
            :description="$t('travel_plans.delete_modal.description')"
            :loading="loading"
            :sticky-header="true"
            @save="deleteTravelPlan"
            @close="closeDeleteTravelPlanModal"
            save-text="Delete"
            :hide-top-close-button="true"
            max-width="450"
            primary-button-class="red white--text"
        />
    </div>
</template>

<script>
import axios from 'axios';
import { fullDateFormat } from '@/components/calendar/config';
import Modal from '@/components/Modal.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    Modal,
  },
  props: {
    travelPlans: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      showDeleteTravelPlanModal: false,
      deleteTravelPlanId: undefined,
    };
  },
  computed: {
    ...mapGetters(['loading']),
    headers() {
      return [
        { text: this.$t('Travel plan'), value: 'title' },
        { text: this.$t('Destination'), value: 'city' },
        { text: this.$t('Plan start'), value: 'start' },
        { text: this.$t('Plan end'), value: 'end' },
        { text: this.$t('Form Property Guests'), value: 'guests' },
        { text: this.$t('Created at'), value: 'created_at' },
        { text: '', value: 'actions' },
      ];
    },
  },
  methods: {
    fullDateFormat,
    openDeleteTravelPlanModal(travelPlan) {
      this.deleteTravelPlanId = travelPlan.id;
      this.showDeleteTravelPlanModal = true;
    },
    closeDeleteTravelPlanModal() {
      this.showDeleteTravelPlanModal = false;
      this.deleteTravelPlanId = undefined;
    },
    deleteTravelPlan() {
      if (this.loading || !this.deleteTravelPlanId) {
        return;
      }

      this.$store.dispatch('loading', true);
      axios
        .delete(`travel-planner/${this.deleteTravelPlanId}`)
        .then(() => {
          this.$store.dispatch('message', this.$t('travel_plans.delete_success'));
          this.closeDeleteTravelPlanModal();
          this.$emit('deleted');
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            this.$store.dispatch('setErrors', error.response.data.errors);
          }
        })
        .finally(() => {
          this.$store.dispatch('loading', false);
        });
    },
    getGuestsLabel(item) {
      const parts = [this.$tc('adults_count', item.adults, { n: item.adults })];

      if (item.children.length > 0) {
        parts.push(this.$tc('children_count', item.children.length, { n: item.children.length }));
      }

      return parts.join(', ');
    },
  },
};

</script>

<style scoped>
.travel-plan-city-image-wrapper {
    width: 100px;
    height: 70px;
    flex: 0 0 100px;
    overflow: hidden;
}

.travel-plan-city-image-wrapper .v-image {
    width: 100%;
    height: 100%;
}

.travel-plan-city-image-wrapper .v-image ::v-deep .v-image__image {
    background-size: cover;
}
</style>
